import React from 'react';
import { useInView } from '../hooks/useInView';

const ProjectCard = ({ project, monthNames, onShow }) => {
    const { ref, inView } = useInView();

    const completionDate = new Date(project.date.seconds * 1000);
    const stringCompletionDate = `${monthNames[completionDate.getMonth()]} ${completionDate.getFullYear()}`;

    return (
        <div
            ref={ref}
            className={`project-card fade-in-up hover-scale ${inView ? 'animation-active' : ''}`}
            onClick={() => onShow(project)}>
            <h2 className="project-name">{project.name}</h2>
            <h3 className="project-subtitle">{project.subtitle}</h3>
            <p className="project-date">{stringCompletionDate}</p>
            <img className="project-mainpreview-image" src={project.images[0]} alt="" />
        </div>
    );
};

export default ProjectCard;
